// extracted by mini-css-extract-plugin
export default {"conicGradinent":"edit-color-modal_conicGradinent__13kC8","pearl":"edit-color-modal_pearl__y0blH"};